if (!customElements.get('variant-columns')) {
  customElements.define(
    'variant-columns',
    class VariantColumns extends HTMLElement {
      connectedCallback() {
        this.sliderEl = this.querySelector('[data-columns-slider]');
        if (!this.sliderEl) return;

        this.items = Array.from(this.sliderEl.querySelectorAll('[data-slider-item]'));
        this.colorByItem = new Map();
        this.knownColors = new Set();
        this.items.forEach((element) => {
          const colors = (element.dataset.variantColor || '')
            .split(',')
            .map((value) => value.trim().toLowerCase())
            .filter(Boolean);
          this.colorByItem.set(element, colors);
          colors.forEach((color) => this.knownColors.add(color));
        });

        const initialTarget = this.items.filter((element) => !element.classList.contains('variant-columns__item--hidden'));
        this.items.forEach((element) => element.classList.remove('variant-columns__item--hidden'));

        this.showElements(initialTarget);

        this.onVariantChange = this.handleVariantChange.bind(this);
        if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      handleVariantChange(payload) {
        const variant = payload?.data?.variant;
        if (!variant || !Array.isArray(variant.options)) return;

        const options = variant.options.map((value) => String(value).trim().toLowerCase());
        const color = options.find((value) => this.knownColors.has(value)) || '';

        const target = this.items.filter((element) => {
          const itemColors = this.colorByItem.get(element);
          return itemColors.length === 0 || itemColors.includes(color);
        });

        this.showElements(target);
      }

      showElements(targetElements) {
        const flkty = window.theme?.Flickity ? window.theme.Flickity.data(this.sliderEl) : null;

        if (flkty && flkty.cells) {
          const currentElements = flkty.cells.map((cell) => cell.element);
          const toAdd = targetElements.filter((element) => currentElements.indexOf(element) === -1);
          const toRemove = currentElements.filter((element) => targetElements.indexOf(element) === -1);
          if (toAdd.length) flkty.append(toAdd);
          if (toRemove.length) flkty.remove(toRemove);
          try {
            flkty.select(0, false, true);
            flkty.resize();
            if (typeof this.sliderEl.setSliderArrowsPosition === 'function') {
              this.sliderEl.setSliderArrowsPosition(this.sliderEl);
            }
          } catch (error) {
            console.warn('variant-columns: Flickity refresh skipped:', error);
          }
        } else {
          targetElements.forEach((element) => this.sliderEl.appendChild(element));
          this.items.forEach((element) => {
            if (targetElements.indexOf(element) === -1 && element.parentNode) {
              element.parentNode.removeChild(element);
            }
          });
          if (typeof this.sliderEl.checkSlidesSize === 'function') {
            this.sliderEl.checkSlidesSize();
          }
        }

        this.clearLoadingState();
      }

      clearLoadingState() {
        this.sliderEl.querySelectorAll('img.is-loading').forEach((image) => {
          const clear = () => {
            image.classList.remove('is-loading');
            if (image.parentNode) image.parentNode.classList.remove('is-loading');
          };
          if (image.complete) {
            clear();
          } else {
            image.addEventListener('load', clear, { once: true });
          }
        });
      }
    }
  );
}
